module.exports = __webpack_public_path__ + "static/img/icon-toss.2da26071.png";